export const CONFIG_FILE_NAME = "nanoforge.config.json";
export const MANIFEST_FILE_NAME = "nanoforge.manifest.json";
export const GLOBAL_CONFIG_FILE_NAME = ".nanoforgerc";
export const DEFAULT_DIRECTORY = ".";
export const NANOFORGE_DIR = ".nanoforge";
export const REGISTRY_URL = process.env.REGISTRY_URL;
